<template>
    <div class="google-login">
        <button 
            @click="login" 
            id="google-login-button"
            class="p2b c7 google-btn">
                <GoogleIcon/>
                {{authType.btnText}} with Google
        </button>
    </div>
</template>

<script>
import * as firebase from "firebase"
import {UserService} from '../core/services'
import {GoogleIcon} from './Icons'
import {PROFILE_PIC_PLACEHOLDER} from "../constants";
import {mapState} from 'vuex'
import {useStripe, useStore, useRouter} from '../core/hooks'
import {computed} from '@vue/composition-api'
import { referralUseCase } from '../core/usecases'
import {attachShopToRealOwner} from '../firebase'

export default {
    name: 'GoogleLogin',
    components: {
        GoogleIcon
    },
    props: {
        authType: Object
    },
    setup(props, {root}) {
        const {state, store} = useStore()
        const { route, router } = useRouter()
        const modals = computed(() => state.value.modals)
        const {redirectToCheckout} = useStripe()

        const isEcommercePlatform = computed(() => store.getters.isEcommercePlatform)

        const setupMixpanelProfile = ({email, displayName, name}, chosenPlanOnSignup) => {
            let userMixpanelProfileProps = [
                email,
                displayName || name, 
                'google.com',
            ]

            if(!isEcommercePlatform.value) {
                userMixpanelProfileProps.push(chosenPlanOnSignup && chosenPlanOnSignup.name === 'premium')
            }

            root.$setUpMixpanelUser(...userMixpanelProfileProps)
        }

        const login = () => {
            const provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithPopup(provider).then(
                async (result) => {
                    result.user
                            .updateProfile({
                                platform: state.value.platform
                            })
                            .catch(console.log)

                    const chosenPlanOnSignup = modals.value['sign-up'] && modals.value['sign-up'].chosenPlanOnSignup || {
                        chosenPlanOnSignup: 'basic'
                    }
                    const userDoc = UserService.getUserDoc(store.getters.usersCollection, result.user.uid)
                    const userProfileData = {
                        name: result.user.displayName,
                        email: result.user.email,
                        userId: result.user.uid,
                        user_img: result.user.photoURL && result.user.photoURL.length ? 
                            result.user.photoURL :
                            PROFILE_PIC_PLACEHOLDER,
                        hasMixpanelProfile: true,
                        authProvider: 'google'
                    }

                    if(!isEcommercePlatform.value) {
                        userProfileData.chosenPlanOnSignup = chosenPlanOnSignup
                    }

                    if (result.additionalUserInfo.isNewUser) {

                        await userDoc.set(userProfileData)

                        const added = await attachShopToRealOwner(userProfileData)

                        if(route.value.query.refId) {
                            root.$sendMixpanelEvent('Signup With Referral Link', {
                                RefId: route.value.query.refId,
                                UserEmail: result.user.email
                            })
                            root.$ga.event('Referral', 'Signup With Referral Link', `
                                RefId: ${route.value.query.refId},
                                UserEmail: ${result.user.email}
                            `)
                            referralUseCase.updateMyReferral(`referral-${route.value.query.refId}`, result.user.uid, result.user.email)
                        }
                        else {
                            referralUseCase.updateMyReferral('', result.user.uid, result.user.email)
                        }

                        root.$sendMixpanelEvent('Sign Up')

                        let eventProps = `
                            AuthType: Google,
                            Email: ${result.user.email},
                            Date: ${new Date().toISOString()},
                        `;

                        if(!isEcommercePlatform.value) {
                            eventProps+= `SignupType: ${chosenPlanOnSignup.name === 'premium' ? 'Premium' : 'Basic'}`
                        }

                        root.$ga.event('Auth', 'Sign Up', eventProps)

                        setupMixpanelProfile(result.user, chosenPlanOnSignup)

                    } else {

                        let userSnapshot = await userDoc.get()
                        let userData = null


                        if(userSnapshot.exists) {
                            userData = userSnapshot.data()
                        }
                        else if(!userSnapshot.exists && isEcommercePlatform.value) {
                            delete userProfileData.hasMixpanelProfile
                            userData = {...userProfileData}
                            await userDoc.set(userProfileData)
                        }

                        root.$sendMixpanelEvent('Login')

                        if(userData.hasMixpanelProfile) {
                            root.$identifyMixpanelUser(userData.email)
                        } else {
                            userDoc.update({
                                hasMixpanelProfile: true
                            })

                            setupMixpanelProfile(userData, chosenPlanOnSignup)
                           
                        }

                        root.$ga.event('Auth', 'Login', `
                            Email: ${userData.email},
                            Date: ${new Date().toISOString()}
                        `)
                    }
                    store.dispatch('auth').then(() => {
                        store.commit('TOGGLE_MODAL', [props.authType.term, false])
                        if(chosenPlanOnSignup.name === 'premium' && chosenPlanOnSignup.priceId) {
                            return redirectToCheckout({
                                stripeInstance: root.$stripe,
                                priceId: state.value.user.chosenPlanOnSignup.priceId
                            })
                        } else {
                            router.push('/browse')
                            .catch(() => {})
                        }
                    })
                }
            ).catch(console.error)
        }

        return {
            login
        }
    },
}
</script>

<style scoped lang="scss">
.google-btn {
    width: 100%;
    height: 48px;
    background: #F4F4F4;
    border-radius: 5px;
    transition: all 0.2s ease;

    &:hover {
        box-shadow: 0px 4px 8px #858585;
    }
}
</style>